import React from "react";
import { Box, Text, Divider, Anchor } from "@mantine/core";

export const MaintenanceInfo = () => {
  return (
    <Box>
      <Text fz="xl" fw={700} mb={8}>
        メンテナンス・障害情報
      </Text>
      <Divider my="sm" />
      <Text mt={16}>
        最新のメンテナンス・障害情報は、以下サイトをご確認ください。
      </Text>
      <Box>
          ・
        <Anchor
          href="https://collaboflow.zendesk.com/hc/ja/sections/201208825"
          target="_blank"
        >
          メンテナンス情報
        </Anchor>
      </Box>
      <Box mb={10}>
          ・
        <Anchor
          href="https://collaboflow.zendesk.com/hc/ja/sections/360000222596"
          target="_blank"
        >
          障害情報
        </Anchor>
      </Box>
    </Box>
  );
};
